module.exports = __webpack_public_path__ + "static/DSC_6601-2e972962ab9d6958e0e0a46b402e16a8.png";